import { useEffect, useState } from 'react';
import ExperienceList from './ExperienceList';

function Experience() {
  const [experiences, setExperiences] = useState([]);
  
  useEffect(() => {
    fetchExperiences()
  }, []); // Pass an empty dependency array to run only once


  const fetchExperiences = async () => {
    await fetch('https://p3d8aepnlk.execute-api.us-west-1.amazonaws.com/prod/experiences')
    .then((res) => {
      return res.json()
    })
    .then((data) => {
      sortExpList(data.Items)
    })
    .catch((error) => {
      console.error("Error fetching experiences:", error)
    });
  }

  const sortExpList = (items) => {
    items.sort((a, b) => b.index - a.index)
    setExperiences(items)
  }

  return (
    <div id="experience">
      <h2 className="experience-title section-title white-text">Experience</h2>
      <div className="experience-body section-body">
        <ExperienceList expList={ experiences } />

        <a className="download-resume white-text" href="https://johann-portfolio-react.s3.us-west-1.amazonaws.com/Johann_Lee_Resume.pdf" target="_blank" rel="noreferrer">
          View Full Resume 
          <span className="download-icon">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 20 20" 
              fill="currentColor" 
              stroke="currentColor" 
              strokeWidth="1.5" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              aria-hidden="true">
              <path d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z" />
            </svg>
          </span>
        </a>
      </div>
    </div>
  );
}

export default Experience;